import React from 'react';
import { Container } from './styles';

interface OrderByFilterProps {
  label: string;
  orderedBy: string;
  orderDirection: 'asc' | 'desc';
  handle: (selectedOrder: string) => void;
}

interface OrderButton {
  key: string;
  label: string;
}

const ORDER_BUTTONS: OrderButton[] = [
  { key: 'deadline', label: 'Prazo' },
  { key: 'modified', label: 'Atualizada em' },
  { key: 'favorited', label: 'Favoritado em' },
];

const OrderByFilter = (props: OrderByFilterProps) => {
  const { label, orderedBy, orderDirection, handle } = props;

  return (
    <Container className="col-12">
      <div className="mr-3 mb-1">{label}</div>
      {ORDER_BUTTONS.map(({ key, label: buttonLabel }, index) => {
        const isActive = orderedBy === key;
        const isAsc = orderDirection === 'asc';
        const spacingClass = index === 0 ? 'mr-1' : 'ml-1';
        return (
          <button
            key={key}
            className={`${spacingClass} btn btn-sm ${
              isActive ? 'btn-primary' : 'btn-outline-primary'
            }`}
            type="button"
            onClick={() => handle(key)}
          >
            {buttonLabel}
            {isActive && (
              <i className="material-icons order-direction align-middle ml-1">
                {isAsc ? 'arrow_upward' : 'arrow_downward'}
              </i>
            )}
          </button>
        );
      })}
    </Container>
  );
};

export default OrderByFilter;
